import styled from 'styled-components';

export const FormGroupContainer = styled.div`
  margin-top: 1.9rem;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-top: 2.4rem;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Informations/elements.js